module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step2_Image21.27da516b.jpg";